<template>
  <div class="ChapterIntro" :style="{ backgroundImage: getGradient() }">
    <div class="ChapterIntro__titles" ref="titles" v-if="chapter.index !== 0">
      <div class="ChapterIntro__title is-t1">{{ trans('Global.chapter') }} {{ chapter.index }}</div>
      <div class="ChapterIntro__title is-t2">{{ chapter[lang].title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChapterIntro',
  props: ['chapter'],
  mounted() {
    if(this.$refs.titles)
      TweenLite.from(this.$refs.titles, 1, { delay: .5, alpha: 0, y: 20 })

    if(this.chapter.key == 'introduction')
      TweenLite.to(this.$el, 1, { alpha: 0 })
  },
  methods: {
    start() {

      const tl = new TimelineMax({})

      if(this.$root.isModeVideo) {
        
        if(this.chapter.key != 'introduction') tl.to(this.$el, 2, { y: -window.innerHeight, alpha: 0, ease: Expo.easeInOut })
        return new Promise(res => { res() })

      } else {

        return new Promise(res => {
          if(this.chapter.key == 'introduction') {
            return res()
          }
          const tl = new TimelineMax({ onComplete: res })
            tl.to(this.$el, 3, { y: -window.innerHeight, alpha: 0, ease: Expo.easeInOut })

          if(this.$root.mode.dev)
            tl.timeScale(10)
        })
      }
    },
    getGradient() {
      const endColor = this.hexToRGB(this.chapter.colors.secondary, 0)
      return `linear-gradient(to bottom, ${this.chapter.colors.primary}, ${this.chapter.colors.secondary}, ${endColor})`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ChapterIntro
  position absolute
  top 0
  left 0
  width 100%
  height 200%
  pointer-events none

  &__titles
    position absolute
    left 40px
    top 30vh

  &__title
    font-size 42px
    +below(phone)
      font-size 30px
      width 80%
    &.is-t1
      font-weight 100
      white-space nowrap
    &.is-t2
      margin-top 25px
      font-weight 700


</style>
